module.exports = __webpack_public_path__ + "img/fb-icon.3f335e73.svg";